import axios from "axios";
import authHeader from "./auth-header";

import api from '../config/api.routes';

const list = (data) => {
  let url = api().PUSH_LIST + `?`;
  for (let query of Object.keys(data)) {
    if (data[query] === undefined || data[query] === '') {
      continue;
    }
    url += `${query}=${encodeURIComponent(data[query])}&`;
  }
  console.log(url);
  return axios.get(url, { headers: authHeader() });
};

const users = (data) => {
  let url = api().PUSH_USER_LIST + `?`;
  for (let query of Object.keys(data)) {
    if (data[query] === undefined || data[query] === '') {
      continue;
    }
    url += `${query}=${encodeURIComponent(data[query])}&`;
  }
  console.log(url);
  return axios.get(url, { headers: authHeader() });
};

const send = ({ message, userId }) => {
  const data = {
    message,
    progress: true
  };

  if (userId) {
    data.userId = userId;
  }

  return axios.post(api().PUSH_SEND, data, { headers: authHeader() });
};

const sendStatus = ({ jobId }) => {
  return axios.get(`${api().PUSH_SEND_STATUS}?jobId=${encodeURIComponent(jobId)}`, { headers: authHeader() });
};

const pushService = {
  list,
  users,
  send,
  sendStatus
}

export default pushService;
